@if (loading){
загрузка
}@else{

@if (!buypoint){
ошибка
} @else {
<div class="space8">
    @if (query){
    <h2>Создать запрос в кредитный отдел</h2>
    <p>{{buypoint.name}} </p>
    <p>ИНН {{buypoint.inn}} </p>
    <p>код {{buypoint.code}} </p>

    <div>
         
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [(ngModel)]="query.Type">

            <mat-radio-button class="example-radio-button" value="Снятие стопа">Снятие блокировки</mat-radio-button>
            <mat-radio-button class="example-radio-button" value="Увеличение лимита">Увеличение
                лимита</mat-radio-button>

        </mat-radio-group>
    </div>

    <div>
        @if (query.Type === "Увеличение лимита"){


        <div>
            <mat-radio-group class="example-radio-group" [(ngModel)]="query.SubType">

                <mat-radio-button class="example-radio-button" value="По ТТ">По ТТ</mat-radio-button>
                <mat-radio-button class="example-radio-button" value="По клиенту">По клиенту</mat-radio-button>

            </mat-radio-group>
        </div>
        @switch (query.SubType) {
        @case ("По ТТ") {
        <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>Сумма</mat-label>
            <input matInput type="number" [(ngModel)]="query.LimitBuypoint">
        </mat-form-field>
        }
        @case ("По клиенту") {
        <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>Сумма</mat-label>
            <input matInput type="number" [(ngModel)]="query.LimitClient">
        </mat-form-field>
        }

        }
        }
    </div>
    <div class="space8">
        <label for="note">Причина запроса</label>
        <br>
        <textarea id="note" style="width: 90%" rows="4" [(ngModel)]="query.Note"></textarea>
    </div>

    }@else {
    <h1 style="color: red">произошла ошибка</h1>
    }
</div>

<!--
<div class="space8">


    <ul>
        @for (img of query.Images; track img){
        <li>
            <img [src]="img" [alt]="img">
        </li>
        }
    </ul>

    <input type="file" hidden #fileInput (change)="uploadFile($event)">
    <button mat-flat-button color="accent air" (click)="fileInput.click()" [disabled]="loading">Приложить файл</button>

</div>
-->

<div class="space8">



    <button mat-flat-button color="warn air" (click)="save()">Отправить</button>


    @if (buypoint.isOwn){
    <button mat-flat-button [routerLink]="['/ors',buypoint.id]" color="primary" [disabled]="loading">Отмена</button>
    }@else{
    <button mat-flat-button [routerLink]="['/client',buypoint.id]" color="primary" [disabled]="loading">Отмена</button>
    }




</div>

}
}